export enum DeactivateActionTypes {
    DEACTIVATE_START = 'DEACTIVATE_START',
    DEACTIVATE_SUCCESS = 'DEACTIVATE_SUCCESS',
    DEACTIVATE_FAILURE = 'DEACTIVATE_FAILURE',
};

export interface DeactivateState {
    isDeactivated: boolean;
    isDeactivating: boolean;
    deactivateErrorMessage: string | null;
};

export interface DeactivateStartPayload {
    messageId: string;
    programmatic: boolean | undefined;
};

export interface DeactivateSuccessPayload {
    isDeactivated: boolean
};

export interface DeactivateFailurePayload {
    errorMessage: string;
};

export type DeactivateStart = {
    type: typeof DeactivateActionTypes.DEACTIVATE_START;
    payload: DeactivateStartPayload;
};

export type DeactivateSuccess = {
    type: typeof DeactivateActionTypes.DEACTIVATE_SUCCESS;
    payload: DeactivateSuccessPayload;
};

export type DeactivateFailure = {
    type: typeof DeactivateActionTypes.DEACTIVATE_FAILURE;
    payload: DeactivateFailurePayload;
};

export type DeactivateActions =
    | DeactivateStart
    | DeactivateSuccess
    | DeactivateFailure;